<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">My Profile {{Title}}</h4>
        <div class="form-group">
          <label for="UserAccount">User Account *</label>
          <div class="input-group">

            <input type="text" class="required form-control" required id="UserAccount" [(ngModel)]="Doc.UserAccount"
              #UserAccount="ngModel" aria-label="User Account" placeholder="" readonly />
          </div>
          <div [hidden]="UserAccount.valid || UserAccount.pristine" class="alert alert-danger">
            User Account is required
          </div>
        </div>
        <div class="form-group">
          <label for="UserName">User Name *</label>
          <input type="text" class="required form-control" #UserName="ngModel" id="UserName" placeholder="" required
            [(ngModel)]="Doc.UserName" readonly />

          <div [hidden]="UserName.valid || UserName.pristine" class="alert alert-danger">
            User Name is required
          </div>
        </div>
        <div class="form-group">
          <label for="EMail">EMail *</label>
          <input type="text" class="required form-control" #EMail="ngModel" id="EMail" placeholder="" required
            [(ngModel)]="Doc.EMail" readonly />

          <div [hidden]="EMail.valid || EMail.pristine" class="alert alert-danger">
            Mail Address is required
          </div>
        </div>

        <div class="form-group">
          <label for="IsEnabled">IsEnabled</label>

          <ng-select [searchable]="false" [items]="Doc.ddlIsEnabled" id="IsEnabled" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectEnabled" [disabled]="true">
          </ng-select>
        </div>
        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Submit($event)" class="btn btn-success" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
    <div class="hide">
      <input type="hidden" />
    </div>
  </div>
  <!-- ============================================================== -->
  <!-- End Container fluid  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <footer class="footer text-center"></footer>
  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
</div>
